// 模特信息列表
export const modelImgEyeList = [
  {
    photo_id: -1,
    customers_pd: 62,
    photoOrderNum: 0,
    distantEyeY: 1,
    distantEyeX: 68,
    len: 68.01,
    angle: 0.84,
    customers_id: 2162976,
    photo_img:
      'https://df5apg8r0m634.cloudfront.net/images/3d2accead7a9555ced3f6c7b938f27e5.jpg',
    photo_path: 'images/users/2021/1102',
    rEyeX: 140,
    rEyeY: 126,
    lEyeX: 77,
    lEyeY: 126,
    photo_add_time: 11
  },
  {
    photo_id: -2,
    customers_pd: 64,
    photoOrderNum: 0,
    distantEyeY: 1,
    distantEyeX: 62,
    len: 62.01,
    angle: 0.92,
    customers_id: 2162976,
    photo_img:
      'https://df5apg8r0m634.cloudfront.net/images/19cf6b5d4046cb9475b1f64a6440a47f.jpg',
    photo_path: 'images/users/2021/1102',
    rEyeX: 141,
    rEyeY: 125,
    lEyeX: 80,
    lEyeY: 125,
    photo_add_time: 10
  },
  {
    photo_id: -3,
    customers_pd: 63,
    photoOrderNum: 0,
    distantEyeY: 1,
    distantEyeX: 69,
    len: 69.01,
    angle: 0.83,
    customers_id: 2162976,
    photo_img:
      'https://df5apg8r0m634.cloudfront.net/images/823797ac1dd64f4d744fd99bde0f2ad7.jpg',
    photo_path: 'images/users/2021/1102',
    rEyeX: 141,
    rEyeY: 126,
    lEyeX: 75,
    lEyeY: 126,
    photo_add_time: 9
  },
  {
    photo_id: -4,
    customers_pd: 66,
    photoOrderNum: 0,
    distantEyeY: 3,
    distantEyeX: 68,
    len: 68.07,
    angle: 2.53,
    customers_id: 2162976,
    photo_img:
      'https://df5apg8r0m634.cloudfront.net/images/092a10c706ccd7ef3e5e8d2e308dea03.jpg',
    photo_path: 'images/users/2021/1102',
    rEyeX: 141,
    rEyeY: 124,
    lEyeX: 75,
    lEyeY: 124,
    photo_add_time: 8
  },
  {
    photo_id: -5,
    customers_pd: 61,
    photoOrderNum: 0,
    distantEyeY: 2,
    distantEyeX: 63,
    len: 63.03,
    angle: 1.82,
    customers_id: 2162976,
    photo_img:
      'https://df5apg8r0m634.cloudfront.net/images/558b0fbf848ab44aca3db575f0b83457.jpg',
    photo_path: 'images/users/2021/1102',
    rEyeX: 142,
    rEyeY: 126,
    lEyeX: 77,
    lEyeY: 126,
    photo_add_time: 7
  },
  {
    photo_id: -6,
    customers_pd: 60,
    photoOrderNum: 0,
    distantEyeY: 0,
    distantEyeX: 64,
    len: 64,
    angle: 0,
    customers_id: 2162976,
    photo_img:
      'https://df5apg8r0m634.cloudfront.net/images/3f283c1163528f502d555ca6cc425a71.jpg',
    photo_path: 'images/users/2021/1102',
    rEyeX: 140,
    rEyeY: 126,
    lEyeX: 75,
    lEyeY: 126,
    photo_add_time: 6
  },
  {
    photo_id: -7,
    customers_pd: 55,
    photoOrderNum: 0,
    distantEyeY: 1,
    distantEyeX: 58,
    len: 58.01,
    angle: 0.99,
    customers_id: 2162976,
    photo_img:
      'https://df5apg8r0m634.cloudfront.net/images/654004e2e8b0a01038978149b973ed4e.jpg',
    photo_path: 'images/users/2021/1102',
    rEyeX: 141,
    rEyeY: 123,
    lEyeX: 81,
    lEyeY: 123,
    photo_add_time: 5
  },
  {
    photo_id: -8,
    customers_pd: 63,
    photoOrderNum: 0,
    distantEyeY: 2,
    distantEyeX: 74,
    len: 74.03,
    angle: 1.55,
    customers_id: 2162976,
    photo_img:
      'https://df5apg8r0m634.cloudfront.net/images/6b9f039d52c7665a7574a8dbbf99490a.jpg',
    photo_path: 'images/users/2021/1102',
    rEyeX: 147,
    rEyeY: 127,
    lEyeX: 71,
    lEyeY: 127,
    photo_add_time: 4
  },
  {
    photo_id: -9,
    customers_pd: 62,
    photoOrderNum: 0,
    distantEyeY: 2,
    distantEyeX: 69,
    len: 69.03,
    angle: 1.66,
    customers_id: 2162976,
    photo_img:
      'https://df5apg8r0m634.cloudfront.net/images/a381c8e68b6354f34518d5c294325778.jpg',
    photo_path: 'images/users/2021/1102',
    rEyeX: 145,
    rEyeY: 125,
    lEyeX: 78,
    lEyeY: 125,
    photo_add_time: 3
  },
  {
    photo_id: -10,
    customers_pd: 62,
    photoOrderNum: 0,
    distantEyeY: 106,
    distantEyeX: 55,
    len: 119.42,
    angle: 62.58,
    customers_id: 2162976,
    photo_img:
      'https://df5apg8r0m634.cloudfront.net/images/1596d37336f09fe74fd5db8ca414b433.jpg',
    photo_path: 'images/users/2021/1102',
    rEyeX: 145,
    rEyeY: 126,
    lEyeX: 75,
    lEyeY: 126,
    photo_add_time: 2
  },
  {
    photo_id: -11,
    customers_pd: 55,
    photoOrderNum: 0,
    distantEyeY: 1,
    distantEyeX: 55,
    len: 55.01,
    angle: 1.04,
    customers_id: 2162976,
    photo_img:
      ' https://df5apg8r0m634.cloudfront.net/images/0c53153aaa958d63ff1211fd54693c96.jpg',
    photo_path: 'images/users/2021/1102',
    rEyeX: 137,
    rEyeY: 124,
    lEyeX: 81,
    lEyeY: 124,
    photo_add_time: 1
  }
];
